import { z } from 'zod';

export const fileSchema = z.object({
  id: z.string(),
  name: z.string(),
  url: z.string(),
  publicUrl: z.string().url(),
  type: z.string(),
  folderId: z.string().nullable().optional(),
  metadata: z.record(z.string(), z.unknown()),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type FileSchema = z.infer<typeof fileSchema>;

export const fileWithLocationSchema = fileSchema.extend({
  clientId: z.string().nullable(),
  clientName: z.string().nullable(),
  attachmentId: z.string().nullable(),
});

export type FileWithLocationSchema = z.infer<typeof fileWithLocationSchema>;
